import { TIER } from "@/constants/tier";
import { buildOrgUrl } from "@/utils/navigation/orgUrl";

/** Titan's routing tiers: the first URL segment an org lives under. */
export type OrgTier = "msp" | "customer" | "system";

export const ORG_TIERS: readonly OrgTier[] = ["msp", "customer", "system"];

export const isOrgTier = (value: unknown): value is OrgTier =>
  typeof value === "string" && (ORG_TIERS as readonly string[]).includes(value);

/** The tier for an IDP `organisation_type`, null when the type is unknown. Distributor and System
 * both live under `/system/:uuid`, as `Auth/OrgRedirect` routes them on a cold landing. */
export const orgTierOf = (
  organisationType: string | null | undefined,
): OrgTier | null => {
  const type = (organisationType || "").toLowerCase();
  if (!type) return null;
  if (type === TIER.msps.toLowerCase()) return "msp";
  if (type === TIER.customer.toLowerCase()) return "customer";
  return "system";
};

/** Where a navigation to an org lands. `/customer/<uuid>` is the `customer-resolver`, which picks
 * the customer's first enabled solution; the other two go straight to the dashboard. */
export const orgLanding = (tier: OrgTier, uuid: string): string =>
  buildOrgUrl(tier, uuid, tier === "customer" ? "" : "dashboard");
